import { useState, useEffect, useRef } from "react";
import { Button, Flex, Popconfirm, Space, Table, Typography, notification } from "antd";
import { DeleteOutlined, EyeFilled } from "@ant-design/icons";
import dayjs from "dayjs";
import CrearGrupo from "../../Paginas/Prueba/Listado/Componentes/CrearGrupo";
import { Link } from "react-router-dom";
import { useForm } from "antd/es/form/Form";
import  {usePrueba}  from "../../Hooks/Prueba/usePrueba";
import useSesion from "../../Hooks/Sesion";
import  {FiltrosPruebas}  from "./FiltrosPruebas";
import { guardarFiltroPruebas, leerFiltroPruebas, restaurarFiltroPruebas } from "../../Util/filtroPruebasStorage";
import { cantidadRepsPrueba } from "../../Util/pruebaReps";

export const TablePruebas = ({cargando, setCargando}) =>{
    const [seleccionados, setSeleccionados] = useState([])
    const {usuario} = useSesion()
    const { filtro_prueba, setFiltroPrueba } = useSesion()
    const {pruebas,getPruebas,deletePrueba, cargarFecha} = usePrueba()
    const [form] = useForm()
    const filtroInicializado = useRef(false)

    const cargar = async (payload) => {
        setCargando(true)
        const filtro = {
            ...payload,
            institucion: usuario?.rol === "Admin" ? payload.institucion : usuario?.institucion,
        }
        setFiltroPrueba((prev) => ({
            ...prev,
            fecha: filtro.fecha,
            tipoPrueba: filtro.tipoPrueba,
            momento: filtro.momento,
            atleta: filtro.atleta,
            instiucion: filtro.institucion,
        }))
        if (usuario?._id) {
            guardarFiltroPruebas(usuario._id, filtro)
        }
        try {
            await getPruebas(filtro)
        } catch (err) {
            notification.error({
                description:
                    err?.response?.data?.mensaje ||
                    err?.message ||
                    "No se pudieron cargar las pruebas. Verifica que el servidor esté activo.",
            })
        } finally {
            setCargando(false)
        }
    }

    const borrar=async (prueba)=>{
        try{
            setCargando(true)
            await deletePrueba(prueba)
            cargar(filtro_prueba)
            notification.success({
                message:'Prueba borrada'
            })
        }catch(err){
            notification.error({
                description:err?.response?.data?.mensaje || err.toString(),
                message:'Prueba no borrada'
            })
        }finally{
            await getPruebas(filtro_prueba)
            setCargando(false)
        }
    }

    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            setSeleccionados([...selectedRows.map(s => s._id)])
        }
    };

    useEffect(() => {
        if (!usuario?._id || filtroInicializado.current) return

        const init = async () => {
            filtroInicializado.current = true
            const guardado = leerFiltroPruebas(usuario._id)
            const restaurado = restaurarFiltroPruebas(guardado, usuario)

            if (restaurado) {
                form.setFieldsValue(restaurado.formValues)
                setFiltroPrueba((prev) => ({
                    ...prev,
                    fecha: restaurado.payload.fecha,
                    tipoPrueba: restaurado.payload.tipoPrueba,
                    momento: restaurado.payload.momento,
                    atleta: restaurado.payload.atleta,
                    instiucion: restaurado.payload.institucion,
                }))
                setCargando(true)
                try {
                    await getPruebas(restaurado.payload)
                } catch (err) {
                    notification.error({
                        description:
                            err?.response?.data?.mensaje ||
                            err?.message ||
                            "No se pudieron cargar las pruebas. Verifica que el servidor esté activo.",
                    })
                } finally {
                    setCargando(false)
                }
                return
            }

            try {
                await cargarFecha(form, setFiltroPrueba)
            } catch (err) {
                notification.error({
                    description:
                        err?.response?.data?.mensaje ||
                        err?.message ||
                        "No se pudo inicializar el filtro de fechas.",
                })
            }
        }

        void init()
    }, [usuario, cargarFecha, form, setFiltroPrueba, getPruebas, setCargando])
    return(
        <>
            <FiltrosPruebas cargar={cargar} form={form} cargando={cargando} />
            
            <Space direction="vertical" style={{ width: '100%' }} align="center">
                <Typography.Title level={1} style={{ fontSize: '28px', fontWeight: 'bold', textAlign: 'center' }}>
                    Pruebas
                </Typography.Title>
            </Space>
            <Table 
                rowKey={'_id'} 
                rowSelection={{
                    type: 'checkbox',
                    ...rowSelection,
                }} 
                loading={cargando} 
                dataSource={pruebas} 
                pagination={false}
                scroll={{ x: 'max-content', y: 300 }}
                locale={{
                    triggerAsc: 'Clic para ordenar alfabéticamente (A-Z)',
                    triggerDesc: 'Clic para ordenar alfabéticamente (Z-A)',
                    cancelSort: 'Clic para cancelar el orden',
                }}
            >
                <Table.Column title="Fecha" dataIndex={'createdAt'} render={(v) => dayjs(v).format("YYYY/MM/DD hh:mm a")} width="20%"/>
                <Table.Column title="Tipo" dataIndex={'tipoPrueba'} />
                <Table.Column title="Momento" dataIndex={'momento'} />
                
                <Table.Column title="Identificación" dataIndex={'atleta'} render={(d) => d?.ide} />
                <Table.Column
                    title="Atleta"
                    dataIndex={['atleta', 'nombre']}
                    sorter={(a, b) =>
                        (a?.atleta?.nombre ?? '').localeCompare(b?.atleta?.nombre ?? '', 'es', {
                            sensitivity: 'base',
                        })
                    }
                    sortDirections={['ascend', 'descend']}
                    render={(nombre) => nombre}
                />
                <Table.Column
                    title="Reps"
                    dataIndex="cantidadReps"
                    width={72}
                    align="center"
                    render={(_, record) => cantidadRepsPrueba(record)}
                />
                <Table.Column title="Acciones" render={(d) => (<Flex gap={'middle'}>
                    <Link to={`/prueba/${d._id}`}><Button shape="circle" icon={<EyeFilled />} /></Link>
                    
                        <Popconfirm title="No prodras recuperar los datos de esta prueba" onConfirm={()=>borrar(d)}>
                        <Button danger shape="circle" icon={<DeleteOutlined />} />
                        </Popconfirm>
                
                </Flex>)} />
            </Table>
            <br></br>
        
            <CrearGrupo registros={seleccionados} isMuestra={false} />
        </>
    )
}
